module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-BoldItalic-Cy-Web.b7f3b59d.woff2";